//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import AlignFigureUI from "./alignFigure/alignFigureUI";
import AlignFigureEditing from "./alignFigure/alignFigureEditing";

export default class AlignFigure extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  public static get requires() {
    return [AlignFigureEditing, AlignFigureUI];
  }
  // noinspection JSUnusedGlobalSymbols
  public static get pluginName() {
    return "AlignFigure";
  }
}
